var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-channel-header" }, [
    _c("ul", { staticClass: "nav go-tab-line" }, [
      _c("li", { staticClass: "go-tab-item" }, [
        _c(
          "a",
          {
            staticClass: "go-tab-link active",
            attrs: { "data-toggle": "tab" },
            on: {
              click: function ($event) {
                return _vm.change(_vm.DISCOVERY_CLOUD_TYPE.ALL)
              },
            },
          },
          [_vm._v("All (" + _vm._s(_vm.totalItems) + ")")]
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "go-tab-item" }, [
        _c(
          "a",
          {
            staticClass: "go-tab-link",
            attrs: { "data-toggle": "tab" },
            on: {
              click: function ($event) {
                return _vm.change(_vm.DISCOVERY_CLOUD_TYPE.GOOGLE_DRIVE)
              },
            },
          },
          [
            _vm._v(
              "Google Drive (" + _vm._s(_vm.countStat("GOOGLE_DRIVE")) + ")"
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "go-tab-item" }, [
        _c(
          "a",
          {
            staticClass: "go-tab-link",
            attrs: { "data-toggle": "tab" },
            on: {
              click: function ($event) {
                return _vm.change(_vm.DISCOVERY_CLOUD_TYPE.ONE_DRIVE)
              },
            },
          },
          [_vm._v("OneDrive (" + _vm._s(_vm.countStat("ONE_DRIVE")) + ")")]
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "go-tab-item" }, [
        _c(
          "a",
          {
            staticClass: "go-tab-link",
            attrs: { "data-toggle": "tab" },
            on: {
              click: function ($event) {
                return _vm.change(_vm.DISCOVERY_CLOUD_TYPE.DROP_BOX)
              },
            },
          },
          [_vm._v("DropBox (" + _vm._s(_vm.countStat("DROP_BOX")) + ")")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }